<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineProps, defineEmits, reactive, ref, onMounted } from 'vue';
    import CustomButton from '@/components/CustomButton.vue';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import axios from 'axios';
    import { useToastStore } from '@/stores/toast.store';

    const props = defineProps({
        collectivite: { type: Object, required: true }
    });
    const emits = defineEmits(['updated']);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const itemsList = ref([] as any[]);
    const paginatedDatas = ref([] as Array<any>);
    const confirmationStore = useConfirmationStore();
    const toastStore = useToastStore();
    const loading = ref(false);

    onMounted(() => {
        doListCarteItems();
    });

    async function doListCarteItems() {
        try {
            loading.value = true;
            const httpResponse = await axios.get(`/backoffice/collectivites/${props.collectivite.id}/get_collectivite_cartes_datas`);
            itemsList.value = httpResponse.data.data;
            pagination.total = itemsList.value.length;
            onPaginate(queryParams.pageNumber);
        } catch (error: any) {
            toastStore.error(error.message ?? "Une erreur est survenue lors de la requête au serveur");
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        const start = (page - 1) * pagination.per_page;
        paginatedDatas.value =  itemsList.value.slice(start, start + pagination.per_page);
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
    }

    async function doAssignCardToUser(user_infos: any) {
        const confirmation = await confirmationStore.open(
            "Assignation Carte",
            `Voulez-vous vraiment assigner une carte à l'utilisateur '${user_infos.nom_user + ' ' + user_infos.prenom_user}' ?`
        );
        if (confirmation) {
            try {
                loading.value = true;
                const httpResponse = await axios.post(`/backoffice/users/${user_infos.user_id}/cartes/assigner_carte`, {});
                toastStore.success("Carte assigné avec succès.");
                emits('updated', httpResponse.data);
            } catch (error: any) {
                toastStore.error(error.message ?? "Une erreur est survenue lors de la requête au serveur");
            } finally {
                loading.value = false;
            }
        }
    }
</script>
<template>
    <div class="s20 widget px-6 pt-8 pb-2">
        <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
            <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                Gérer les cartes
            </span>
        </div>
        <!-- <div class="s10 mt--5-5 flex-right">
            <button class="btn lg py-3 white2 active">
                <img src="/icons/icon-telecharger.svg" class="btn-icon" alt="" />
                <span>Modèle de fichier csv</span>
            </button>
        </div> -->

        <div class="s20 items-center gap-6 px-0 pb-6 collapse-content active">
            <!--Card-->
            <div>
                <div class="container-full-2 s20 mt-1 mb-5">
                    <div class="s7"><h4 class="font-semibold mt-4">Cartes <span class="text-sm text-grey-500">(recent)</span></h4></div>
                    <div class="s13 flex justify-content-right">
                        <button class="btn normal ml-4 justify-content-center btn-filtre">
                            <img src="/icons/icon-add.svg" class="btn-icon" alt="" />
                            <span>Créer</span>
                        </button>
                        <div class="form-field-floating default sm s4_mobile ml-3">
                            <select class="form-input-select" name="pays" id="pays">
                                <option value="" selected>Tous les lots</option>
                                <option value="">Lot1</option>
                            </select>
                        </div>
                        <div class="form-field-floating default sm s4_mobile ml-3">
                            <select class="form-input-select" name="pays" id="pays">
                                <option value="">Trier</option>
                                <option value="" selected>Ordre Décroissant</option>
                                <option value="">Ordre Croissant</option>
                                <option value="">De A - Z</option>
                                <option value="">De Z - A</option>
                            </select>
                        </div>
                        <button class="btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter">
                            <img src="/icons/icon-filter.svg" class="btn-icon" alt="" />
                            <span>Options</span>
                        </button>
                    </div>
                    <div class="clear-both"></div>
                    <!--Options-->
                    <div class="filter-set-area">
                        <div class="grid-filter6 mt-4 mb-0">
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date1" id="date1" placeholder="">
                                <label for="date1">Date de création &lt;=</label>
                            </div>
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date2" id="date2" placeholder="">
                                <label for="date2">Date de création &gt;=</label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                                <span>Exporter Excel</span>
                            </button>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                                <span>Exporter PDF</span>
                            </button>
                        </div>
                    </div>
                    <!---->
                </div>
                <table class="table separator skin1 sm selection"><!-- selection skin1 skin2 (bg1 bg2 bg3)  (skin3 rounded)  sm-->
                    <thead>
                        <tr>
                            <th><label class="btn-circle" for="check-list1"><input type="checkbox" name="check-list" id="check-list1" /></label></th>
                            <th></th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Nom &amp; Prénoms</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Numéro</th>
                            <th><img src="/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" /> N° de Lot</th>
                            <th><img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" /> Banque</th>
                            <th><img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" /> Date de création</th>
                            <th><img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" /> Etat</th>
                            <th><img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" /> Statut</th>
                            <th class="flex-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-grey-700 over-effect over-effect-scale" v-for="(carte, index) of paginatedDatas" :key="index"><!-- over-effect active-->
                            <td class="selection-item"><label class="btn-circle" for="check-list1"><input type="checkbox" name="check-list" id="check-list1" /></label></td>
                            <td>
                                <!-- <div class="square-lg px-3 py-3" style="background-color: rgb(var(--color-success-rgb), 0.2);">
                                    <img src="/icons/icon-menu-carte.svg" width="100%" />
                                </div> -->
                                <div class="square-xl rounded-15" style="background-color: rgb(var(--color-warning-rgb), 0.2);"><img :src="'/assets/users_avatar/600w/user.jpg'" width="100%" /></div>
                            </td>
                            <td class="font-semibold text-xl">{{ carte.nom_user + ' ' + carte.prenom_user }}</td>
                            <td class="font-semibold text-xl">{{ carte.numero_masque_carte ?? '-' }}</td>
                            <td>{{ carte.num_lot_carte ?? '-' }}</td>
                            <td>{{ carte.nom_banque_carte ?? '-' }}</td>
                            <td>{{ carte.created_at_carte ?? '-' }}</td>
                            <td><span class="tag-state stroke" :class="{'success': carte.etat_assignation, 'warning': !carte.etat_assignation}">{{ carte.etat_assignation ? 'Assigné' : 'Aucune carte assigné' }}</span></td>
                            <td>
                                <span class="tag-state stroke" :class="{'success': ['delivered', 'active'].lastIndexOf(carte.statut_carte) > -1, 'warning': ['delivered', 'active'].lastIndexOf(carte.statut_carte) == -1 }" v-if="carte.etat_assignation">{{ carte.statut_label }}</span>
                            </td>
                            <td>
                                <div class="flex-right">
                                    <custom-button type="button" :classesList="'btn-ultra color2'" @click="doAssignCardToUser(carte)" v-if="!carte.carte_id">
                                        <span>Assigner carte</span>
                                    </custom-button>
                                    <template v-else>
                                        <custom-button type="button" :classesList="'btn-ultra'">
                                            <img src="/icons/icon-valider.svg" class="btn-icon icon-neutral" alt="" />
                                            <span>En&nbsp;livraison</span>
                                        </custom-button>
                                        <custom-button type="button" :classesList="'btn-ultra color2 tips'">
                                                <img src="/icons/icon-actif.svg" class="btn-icon" alt="" />
                                                <span>Actif</span>
                                        </custom-button>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
        </div>
    </div>
    
</template>